
import Vue, { PropType } from "vue";

interface InterviewDetails {
  title: string;
  date: string;
  formattedDate: string;
  formattedTime: string;
  role: string;
  format: string;
  duration: string;
  transcriptVia: string;
  link: string;
  validationAreas: string[];
  interviewerEmail?: string;
  meetingId?: string;
  meetingPasscode?: string;
}

export default Vue.extend({
  name: "AiInterviewDetailsCard",
  props: {
    title: {
      type: String,
      default: "Interview Details"
    },
    joinLabel: {
      type: String,
      default: "Join"
    },
    joinDisabled: {
      type: Boolean,
      default: false
    },
    validationAreasLabel: {
      type: String,
      default: "Critical Validation Areas"
    },
    interview: {
      type: Object as PropType<InterviewDetails>,
      required: true
    },
    showTeamsInfo: {
      type: Boolean,
      default: false
    },
    transcriptVia: {
      type: String,
      default: "Microsoft Teams"
    }
  },
  computed: {
    month(): string {
      return new Date(this.interview.date).toLocaleString("en-US", {
        month: "short"
      });
    },
    day(): string {
      return new Date(this.interview.date).toLocaleString("en-US", {
        day: "2-digit"
      });
    },
    quickFacts(): { label: string; value: string }[] {
      const facts = [
        {
          label: "Role",
          value: this.interview.role
        },
        {
          label: "Format",
          value: this.interview.format
        },
        {
          label: "Duration",
          value: this.interview.duration
        }
      ];
      if (this.showTeamsInfo) {
        facts.push({ label: "Transcript Via", value: this.transcriptVia });
      } else {
        facts.push({ label: "Interview Mode", value: "On Portal" });
      }
      return facts;
    }
  }
});
